exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-7696a69e] table > tbody > tr > td {\n\tcursor: pointer;\n}\n", ""]);

// exports
